import { 
  Button, 
  Center, 
  Text, 
  Stack, 
  Box,
  Image
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const AdminHero = () => {

  return (
    <>
      <Stack p={6}>
        <Box textAlign="center" py={3}>
          <Image src="/logo512.png" alt="iFun Baby Logo" boxSize="150px" mx="auto" mb={4} />
          <Text fontSize="2xl" fontWeight="bold">iFun Baby Admin</Text>
          <Text fontSize="lg" color="gray.500" mt={2}>Please log in to access the Admin Dashboard!</Text>
        </Box>
        <Center>
          <Link to="/admin/login">
            <Button colorScheme="teal" mr={3}>Log in</Button>
          </Link>
        </Center>
      </Stack>
    </>
  );
};

export default AdminHero;
